<template>
  <div class="info-base-container">
    <div class="left">
      <div>
        <h4>Rödlistning</h4>
        <v-checkbox dense hide-details v-model="nt" label="Nära hotad NT"></v-checkbox>
        <v-checkbox dense hide-details v-model="vu" label="Sårbar VU"></v-checkbox>
        <v-checkbox dense hide-details v-model="en" label="Starkt hotad EN"></v-checkbox>
        <v-checkbox dense hide-details v-model="cr" label="Akut hotad CR"></v-checkbox>
        <v-checkbox dense hide-details v-model="re" label="Nationellt utdöd RE"></v-checkbox>
      </div>
      <div>
        <h4>Arten är</h4>
        <v-checkbox dense hide-details v-model="_alien" label="Främmande art"></v-checkbox>
        <v-checkbox dense hide-details v-model="_freshwater" label="Sötvattenart"></v-checkbox>
        <v-checkbox dense hide-details v-model="_marine" label="Saltvattenart"></v-checkbox>
      </div>
    </div>
    <div>
      <v-textarea class="mt-2" outlined auto-grow label="Arttext" v-model="text"></v-textarea>
      <v-textarea class="mt-2" outlined auto-grow label="Livsmiljö" v-model="envText"></v-textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBase',
  props: {
    alien: { type: String },
    freshwater: { type: String },
    marine: { type: String },
    redlist_nt: { type: String },
    redlist_vu: { type: String },
    redlist_en: { type: String },
    redlist_cr: { type: String },
    redlist_re: { type: String },
    text_sve: { type: String },
    text_env_sve: { type: String },
  },
  data() {
    return {}
  },
  computed: {
    envText: {
      get() {
        return this.text_env_sve
      },
      set(val) {
        this.$emit('change', { text_env_sve: val })
      },
    },
    text: {
      get() {
        return this.text_sve
      },
      set(val) {
        this.$emit('change', { text_sve: val })
      },
    },
    _marine: {
      get() {
        return this.marine === 'on'
      },
      set(val) {
        this.$emit('change', { marine: val ? 'on' : null })
      },
    },
    _freshwater: {
      get() {
        return this.freshwater === 'on'
      },
      set(val) {
        this.$emit('change', { freshwater: val ? 'on' : null })
      },
    },
    _alien: {
      get() {
        return this.alien === 'on'
      },
      set(val) {
        this.$emit('change', { alien: val ? 'on' : null })
      },
    },
    nt: {
      get() {
        return this.redlist_nt === 'on'
      },
      set(val) {
        this.$emit('change', { redlist_nt: val ? 'on' : null })
      },
    },
    vu: {
      get() {
        return this.redlist_vu === 'on'
      },
      set(val) {
        this.$emit('change', { redlist_vu: val ? 'on' : null })
      },
    },
    en: {
      get() {
        return this.redlist_en === 'on'
      },
      set(val) {
        this.$emit('change', { redlist_en: val ? 'on' : null })
      },
    },
    cr: {
      get() {
        return this.redlist_cr === 'on'
      },
      set(val) {
        this.$emit('change', { redlist_cr: val ? 'on' : null })
      },
    },
    re: {
      get() {
        return this.redlist_re === 'on'
      },
      set(val) {
        this.$emit('change', { redlist_re: val ? 'on' : null })
      },
    },
  },
}
</script>

<style lang="less" scoped>
.info-base-container {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 30px;
  grid-row-gap: 0px;
  .left {
    display: flex;
    gap: 30px;
  }
}
</style>
